<template>
    <div class="common-seach-wrap">
        <el-tabs size="small" type="card" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.value" :name="item.key" ></el-tab-pane>
        </el-tabs>
        <List v-if="activeName === 'list'" />
    </div>
</template>
<script>
    import List from './video/index';
    // import Enroll from './enroll/index';
    // import Setting from './setting/index';
    export default {
        components: {
            List,
            // Enroll,
            // Setting,
        },
        data() {
            return {
                /*当前选中*/
                activeName: 'list',
                /*切换数组原始数据*/
                sourceList: [
                    {
                        key: 'list',
                        value: '列表',
                        path:'/education/video/index'
                    },
                    // {
                    //     key: 'enroll',
                    //     value: '参与记录',
                    //     path:'/education/activity/enrollList'
                    // },
                    // {
                    //     key: 'setting',
                    //     value: '活动设置',
                    //     path:'/education/activity/setting/index'
                    // },
                ],
                /*权限筛选后的数据*/
                tabList:[],
            };
        },
        created() {
            this.tabList=this.authFilter();
            if (this.$route.query.type != null) {
                this.activeName = this.$route.query.type;
            }
        },

        methods: {

            handleClick(e) {
                this.activeName = e.name;
            },

            /*权限过滤*/
            authFilter(){
                let list=[];
                for(let i=0;i<this.sourceList.length;i++){
                    let item=this.sourceList[i];
                    if(this.$filter.isAuth(item.path)){
                        list.push(item);
                    }
                }
                return list;
            },

        }
    };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/education/video/index.vue